<template>
  <ResetPassword
    clientType="user"
    :form="form"
    :isLoading="isLoading"
    :submit="submit"
  />
</template>

<script>
// Components
import ResetPassword from 'client/components/forms/ResetPassword.vue';

// Services
import userResetPasswordService from 'client/services/userResetPasswordService';

export default {
  name: 'UserResetPasswordInputHandler',

  components: {
    ResetPassword,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    // Explicit MFA-direct gate — do not infer from empty requestKey alone
    // (email activation form can also lack key).
    isMfaDirect: {
      type: Boolean,
      default: false,
    },
    requestKey: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    async submit() {
      this.isLoading = true;
      this.$emit('resetErrorMessage');
      // eslint-disable-next-line vue/no-mutating-props
      this.form.deviceCode = await userResetPasswordService.getDeviceCertCode();

      try {
        // MFA-direct only: controller runs initMfaReset then MFA (NA-4402).
        // Await `done` so isLoading stays true for the full init + probe.
        if (this.isMfaDirect) {
          await new Promise((resolve) => {
            this.$emit('mfa-direct-ready', { done: resolve });
          });
          return;
        }

        await userResetPasswordService.resetPassword(this.requestKey, this.form);
        this.$emit('success');
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style module>
@import '../../../css/login-components.css';
</style>
